import { io } from "socket.io-client";

const hostname = window.location.hostname;
let url;

if (hostname === "dev.scrollx.io") {
  url = "https://dev.api.scrollx.io";
} else if (hostname === "localhost") {
  url = "http://localhost:8000";
} else {
  url = "https://api.scrollx.io";
}

const socket = io(url, {
  autoConnect: false,
});

export default socket;
